import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RhssoAuthService } from '../services/rhsso-auth.service';
import { environment } from '../../../environments/environment';

/**
 * Guard funcional que protege rotas que exigem autenticação RHSSO.
 *
 * Fluxo (quando environment.rhssoEnabled = true):
 *   1. Token válido → permite acesso imediatamente.
 *   2. Refresh token válido → renova silenciosamente e permite acesso.
 *   3. Sem sessão → redireciona para /auth/redirect (spinner + inicia PKCE).
 *
 * Quando environment.rhssoEnabled = false → permite acesso direto (RHSSO desabilitado).
 */
export const authGuard: CanActivateFn = async () => {
  if (!environment.rhssoEnabled) {
    return true;
  }

  const auth   = inject(RhssoAuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }

  const refreshed = await auth.refresh();
  if (refreshed) {
    return true;
  }

  return router.parseUrl('/auth/redirect');
};
